export default __webpack_public_path__ + "static/media/50_sp.a109a5bc.png";